import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import LinkSocialUserUI from './LinkSocialUserUI.js'

class LinkSocialUserSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: [],
      submitted: false,
      password: '',
      passwordError: null
    }
  }

  render() {
    return (
      <LinkSocialUserUI
        context={this.props.context}
        messageList={this.props.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        provider={this.props.provider}
        // new password
        password={this.state.password}
        passwordError={this.state.passwordError}
        onPasswordChange={(event) => {this.setState({password: event.target.value})}}
        setPasswordError={(error) => {this.setState({passwordError: error})}}
      />
    )
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})

    RestApiUtils.post(this.props.context,
      `/api/pub/socialUserLink`,
      this.onLinkSocialUserCallback, {
        password: this.state.password
      }
    )
  }

  onLinkSocialUserCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'password':
            this.setState({passwordError: error.message})
            break;
          default:
        }
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList
    })

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }
}

export default LinkSocialUserSF
